module.exports = __webpack_public_path__ + "img/topic_c@2x.0e3560c2.png";